import { Flex, Text, Button, Image, Stack, useBreakpointValue } from "@chakra-ui/react";

type CarProps = {
  car: string;
  board: string;
  tire: string;
  source: string;
};

export function TableGa({ car, board, tire, source }: CarProps) {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  return (
    <Flex p="15px 0 15px 5px" borderBottom="1px solid #c3c3c3" w="full" alignItems="center">
      <Flex w={["15%", "5%"]} alignSelf={["start", "center"]}>
        <Image src={source} alt="Garage" maxW="40px" maxH="40px" />
      </Flex>
      <Flex direction={["column", "row"]}>
        <Flex alignItems="center">
          <Text fontWeight="medium" mb={["5px", "0"]}>
            {car}
          </Text>
        </Flex>
        <Flex alignItems="center" ml={["0", "2rem"]} mb={["5px", "0"]}>
          <Text fontWeight="medium">{board}</Text>
        </Flex>
        <Flex alignItems="center" ml={["0", "4rem"]}>
          <Button
            color="white"
            backgroundColor="green.900"
            borderRadius="0"
            fontWeight="bold"
            fontSize="text1"
            width="140px"
            _hover={{ bgColor: "green" }}
          >
            {tire}
          </Button>
        </Flex>
      </Flex>
      <Flex
        w="10%"
        direction="column"
        alignSelf={["end", "center"]}
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        ml={["1rem", "2rem"]}
        mb={["7px", "0"]}
      >
        <Image
          src="https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/dropItem.svg"
          alt="Remover produto"
          w={["20px", "1rem"]}
        />
        {isWideVersion && (
          <Text mt="5px" fontWeight="medium" fontSize="text3">
            Apagar
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
